import controller from './my-payments-list.controller';
import template from './my-payments-list.view.html';

let MyPaymentsListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default MyPaymentsListComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/my-payments/my-payments-list/my-payments-list.component.js
 **/